const TariffPreview = ({ tariff }) => {
  const {
    switchId,
    tilSupplierNameElec,
    tilTariffNameElec,
    annualSavings,
    annualCostElec,
    annualCostGas,
    annualCost,
  } = tariff;

  return (
    <div className="overflow-hidden border-2 border-[#afb6b9] rounded-[4px] p-5">
      <div className="mb-2">
        <h3 className="font-bold text-base mb-1">{tilSupplierNameElec}</h3>
        <h4 className="text-base">{tilTariffNameElec}</h4>
      </div>

      <div className="border border-[#afb6b9] rounded-[4px] p-4">
        <div className="grid grid-cols-2 mb-2">
          <div className="text-base">Your switch reference number:</div>
          <div className="font-bold text-base pl-8">{switchId}</div>
        </div>

        <div className="border-2 border-[#ff0085] rounded-[4px] p-4">
          <div className="grid grid-cols-2 pb-4">
            <span>Estimated yearly electricity cost:</span>
            <span className="font-semibold pl-8">
              £{annualCostElec.toFixed(2) || "0.00"}
            </span>
          </div>
          <div className="grid grid-cols-2 py-4 border-t border-[#afb6b9]">
            <span>Estimated yearly gas cost:</span>
            <span className="font-semibold pl-8">
              £{annualCostGas.toFixed(2) || "0.00"}
            </span>
          </div>
          <div className="grid grid-cols-2 pt-4 border-t border-[#afb6b9]">
            <span>Estimated total:</span>
            <span className="font-semibold pl-8">£{annualCost.toFixed(2)}</span>
          </div>
        </div>

        <div className="grid grid-cols-2 pt-4">
          <span>Amount you could save:</span>
          <span className="font-semibold pl-8">
            £{annualSavings.toFixed(2)}
          </span>
        </div>
      </div>
    </div>
  );
};

export default TariffPreview;
